export default (state, action) => {
  switch (action.type) {
    case 'add':
      return [...state, { DisabilityId: action.payload.id }];
    case 'remove':
      return state.filter(
        answerId => answerId.DisabilityId !== action.payload.id
      );
    default:
      return state;
  }
};
